import { render, staticRenderFns } from "./PerspectiveActiveInstructionsSidebarMenu.vue?vue&type=template&id=756bbbd6&scoped=true&"
import script from "./PerspectiveActiveInstructionsSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./PerspectiveActiveInstructionsSidebarMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756bbbd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('756bbbd6')) {
      api.createRecord('756bbbd6', component.options)
    } else {
      api.reload('756bbbd6', component.options)
    }
    module.hot.accept("./PerspectiveActiveInstructionsSidebarMenu.vue?vue&type=template&id=756bbbd6&scoped=true&", function () {
      api.rerender('756bbbd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Sidebar/SidebarComponents/PerspectiveActiveInstructionsSidebarMenu.vue"
export default component.exports